module.exports = __webpack_public_path__ + "static/media/Logo2.54e32fd6.png";